import(/* webpackMode: "eager", webpackExports: ["default"] */ "/calcom/apps/web/modules/apps/[slug]/slug-view.tsx");
